import type { CurrencyCode } from "@/models/currencyCode"
import type { SortOrder } from "@/models/sort"

export const APP_COMPANY_NAME = "NZero"
export const APP_NAME = `${APP_COMPANY_NAME}OS`
export const APP_NOREPLY_EMAIL = "no-reply@nzero.com"
export const BTU_PER_GJ = 947817
export const CSV_DELIMITER = ","
export const CSV_NEW_LINE = "\r\n"
export const CUBIC_METERS_PER_METRIC_MILLION_BRITISH_THERMAL_UNITS = 26.8391
export const CURRENCY_LOCAL_STORAGE_KEY = "currency"
export const DEFAULT_CURRENCY: CurrencyCode = "USD"
export const EMPTY_DATA_PLACEHOLDER = "--"
export const FOOT_PER_METER = 3.28084
export const GJ_PER_KWH = 0.0036
export const GJ_PER_THERM = 0.1054804
export const KBTU_PER_KWH = 3.412142
export const KBTU_PER_THERM = 99.976
export const KG_PER_METRIC_TON = 1_000
export const KILO = 1_000
export const KWH_PER_MWH = 1_000.0
export const LANGUAGE_LOCAL_STORAGE_KEY = "language"
export const LBS_PER_METRIC_TON = 2_204.62
export const LITERS_PER_GALLON = 3.78541
export const METER_PER_FOOT = 0.3048
export const MEGAJOULES_PER_KILO_BRITISH_THERMAL_UNITS = 1.05506
export const MEGAWATT_HOURS_PER_KILOWATT_HOURS = 0.001
export const METRIC_TONS_PER_POUND = 0.00045359237
export const MAIN_MENU_WIDTH = "56px"
export const MAIN_MENU_TOGGLE_HEIGHT = "76px"
export const MAX_MONTHS_IN_RANGE = 36
export const MEASUREMENT_SYSTEM_LOCAL_STORAGE_KEY = "measurementSystem"
export const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
export const SQUARE_METERS_PER_SQUARE_FOOT = METER_PER_FOOT * METER_PER_FOOT
export const THERMS_PER_MMBTU = 10
export const ASC: SortOrder = "asc"
export const DESC: SortOrder = "desc"
